import { IntegrationInfo } from "@custom-types/integrations-types";
import { SphereDashboardAPITypes } from "@stellar/api-logic";
import ProcoreIcon from "@assets/icons/integrations/procore-icon_50px.svg?react";
import AutodeskIcon from "@assets/icons/integrations/autodesk-icon_50px.svg?react";

/** Information of each integration */
export const INTEGRATION_INFO: Record<SphereDashboardAPITypes.IntegrationId, IntegrationInfo> = {
  [SphereDashboardAPITypes.IntegrationId.autodesk]: {
    displayName: "Autodesk",
    description:
      "Create and view RFIs and Issues directly within the platform.",
    icon: AutodeskIcon,
  },
  [SphereDashboardAPITypes.IntegrationId.procore]: {
    displayName: "Procore",
    description:
      "Create and view RFIs and Observations directly within the platform.",
    icon: ProcoreIcon,
  },
};
